import { render } from "./detail.vue?vue&type=template&id=3f23c2ec&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=3f23c2ec&lang=css"
import "./detail.vue?vue&type=style&index=1&id=3f23c2ec&scoped=true&lang=css"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/1ac9e6a1-3d63-42f4-aa32-2a0557ce8f53/workspace/wellcee-h5-p_H4zR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f23c2ec"]])

export default __exports__